"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useLocale } from "next-intl";
import HospitalResultCardContent from "@/shared/ui/molecules/HospitalResultCardContent";
import { RankingHospitalItem } from "@/widgets/search-ranking/model/types";
import RankingHospitalCardLeading from "@/widgets/search-ranking/ui/molecules/RankingHospitalCardLeading";
import { buildHospitalShortPath } from "@/entities/hospital/lib/detail-route";
interface RankingHospitalCardProps {
  item: RankingHospitalItem;
  onAnchorCapture?: (hospitalOriginId: number, el: HTMLElement | null) => void;
  /** 상세로 나가는 숫자형 canonical 경로. 생략하면 목록의 기본 경로를 사용한다. */
  href?: string;
}
const RankingHospitalCard = t0 => {
  const $ = _c(24);
  const {
    item,
    onAnchorCapture,
    href
  } = t0;
  const locale = useLocale();
  const {
    hospitalOriginId,
    rank,
    previousRank,
    name,
    address,
    score,
    reviewCount,
    imageUrl
  } = item;
  let t1;
  if ($[0] !== hospitalOriginId || $[1] !== href || $[2] !== locale) {
    t1 = href ?? buildHospitalShortPath(locale, hospitalOriginId);
    $[0] = hospitalOriginId;
    $[1] = href;
    $[2] = locale;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== hospitalOriginId || $[5] !== onAnchorCapture) {
    t2 = e => onAnchorCapture?.(hospitalOriginId, e.currentTarget);
    $[4] = hospitalOriginId;
    $[5] = onAnchorCapture;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== previousRank || $[8] !== rank) {
    t3 = <RankingHospitalCardLeading rank={rank} previousRank={previousRank} />;
    $[7] = previousRank;
    $[8] = rank;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== address || $[11] !== imageUrl || $[12] !== name || $[13] !== reviewCount || $[14] !== score) {
    t4 = <HospitalResultCardContent name={name} address={address} score={score} reviewCount={reviewCount} imageUrl={imageUrl} />;
    $[10] = address;
    $[11] = imageUrl;
    $[12] = name;
    $[13] = reviewCount;
    $[14] = score;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t3 || $[17] !== t4) {
    t5 = <div className="flex min-w-0 flex-1 items-center gap-4 py-3.5 pl-3.5 pr-3.5">{t3}{t4}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== hospitalOriginId || $[20] !== t1 || $[21] !== t2 || $[22] !== t5) {
    t6 = <Link href={t1} className="flex min-w-0 w-full rounded-lg bg-white" onClickCapture={t2} data-search-result-anchor={hospitalOriginId}>{t5}</Link>;
    $[19] = hospitalOriginId;
    $[20] = t1;
    $[21] = t2;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
};
export default RankingHospitalCard;